export default __webpack_public_path__ + "static/958-210e1fa3e3e075d8f606a6b76ee797e7.gif";